<template>
    <div class="wf-select">
        <Select :value="value" :disabled="disabled" :filterable="filterable" :placeholder="placeholder" :clearable="clearable" @on-change="handleChange">
            <Option v-for="(item, key) in options" :key="key" :value="item.value">{{ item.label }}</Option>
        </Select>
    </div>
</template>

<script>
import Select from 'iview/src/components/select';
import Option from 'iview/src/components/option';
export default {
    components: {
        Select,
        Option
    },
    data() {
        return {

        }
    },
    props: {
        value: {
            type: String | Number,
            default: ""
        },
        filterable: {
            type: Boolean,
            default: true
        },
        placeholder: {
            type: String,
            default: ""
        },
        clearable: {
            type: Boolean,
            default: true
        },
        options: {
            type: Array,
            default: () => {
                return []
            }
        },
        disabled: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        // select改变事件
        handleChange(value) {
            this.$emit('change', value)
        }
    }
}
</script>

<style lang="scss" scoped>
.wf-select {
	/deep/ .ivu-select-input {
		height: 28px;
	}
    /deep/ .ivu-select-selection {
        height: 30px;
		border-color: #e0e0e0;
    }
	/deep/ .ivu-select-visible .ivu-select-selection {
		border-color: #57a3f3;
	}
    /deep/ .ivu-select-placeholder {
        height: 28px;
        line-height: 28px;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/select/select.vue